// src/index.js
import "./i18n";
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import { MaterialUIControllerProvider } from "context";
import { AuthProvider } from "context/AuthContect";
import { NavbarSearchProvider } from "context/NavbarSearchContext";

const container = document.getElementById("app");
const root = createRoot(container);
root.render(
  <BrowserRouter>
    <AuthProvider>
      <MaterialUIControllerProvider>
        <NavbarSearchProvider>
          <App />
        </NavbarSearchProvider>
      </MaterialUIControllerProvider>
    </AuthProvider>
  </BrowserRouter>
);
